import { Injectable } from '@angular/core';
import { TargetedGroupDataService } from '../data-services/targeted-group-data.service';
import { TargetedGroupModel } from '../business-entities/targeted-group-model';
import { TargetGroupRequestModel } from '../business-entities/campaign-modal';

@Injectable({
  providedIn: 'root',
})
export class TargetedGroupService {
  constructor(private targetedGroupDataService: TargetedGroupDataService) {}

  getTargetedGroups(requestModal: TargetGroupRequestModel): Promise<any> {
    return this.targetedGroupDataService.getTargetedGroups(requestModal);
  }

  addtargetedGroup(param: TargetedGroupModel): Promise<any> {
    return this.targetedGroupDataService.addtargetedGroup(param);
  }

  deleteTargetedgroup(param: number): Promise<any> {
    return this.targetedGroupDataService.deleteTargetedgroup(param);
  }

  async getCampaignMemberByQuery(param: any): Promise<any> {
    return this.targetedGroupDataService.getCampaignMemberByQuery(param);
  }

  async GetCampaignMemberByCampaignId(id: any): Promise<any> {
    return this.targetedGroupDataService.GetCampaignMemberByCampaignId(id);
  }

  async InsertCampaignMembers(param: any): Promise<any> {
    return this.targetedGroupDataService.InsertCampaignMembers(param);
  }
}
